import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { AppState } from '@models/AppState';
import { Observable } from 'rxjs';

import { ApplicationStore } from './application.store';

@Injectable({ providedIn: 'root' })
export class ApplicationQuery extends Query<AppState> {
	constructor(protected store: ApplicationStore) {
		super(store);
	}

	/** Whether or not the overlay loader is shown */
	public readonly loading$ = (): Observable<boolean> => this.select('loading');
	/** The text displayed beneath the large loader */
	public readonly largeLoaderText$ = (): Observable<string> => this.select('largeLoaderText');
	/** Whether or not the large loader should be persisted for a certain amount of time */
	public readonly largeLoaderTimeout$ = (): Observable<number> => this.select('largeLoaderDelay');
	/**
	 * Whether or not the large loader should be persisted for a certain amount of time
	 *
	 * @deprecated
	 */
	public readonly getLargeLoaderTimeout = (): number => this.getValue().largeLoaderDelay;
	/** The current step that the user is on in the user flow */
	public readonly wofklowStep$ = (): Observable<number> => this.select('workflowStep');
	/** The brand of the QE that should be used */
	public readonly brand$ = (): Observable<string> => this.select('brand');
	/** The id of the currently active pet */
	public readonly activePet$ = (): Observable<string | undefined> => this.select('activePet');
	/** The state of the USAA SSO user */
	public readonly ssoState$ = (): Observable<string> => this.select('ssoState');
	/** Whether or not SSO is active for USAA  */
	public readonly isUsaaSsoInactiveFlow$ = (): boolean => this.getValue().usaaSsoInactive;
	/** Whether or not the USAA SSO login was attempted */
	public readonly usaaAttemptedLogin$ = (): Observable<boolean> => this.select('usaaAttemptedLogin');
	/**
	 * The ID of the currently active pet
	 *
	 * @deprecated
	 */
	public readonly getActivePetId = (): string | undefined => this.getValue().activePet;

	public readonly getKameleoonEnabled$ = (): Observable<boolean | undefined> => (this.select('kameleoonEnabled'));
}
